/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookingCancellationDisputeDto } from './BookingCancellationDisputeDto';
import type { BookingDetailExpertDto } from './BookingDetailExpertDto';
import type { BookingDetailLocationDto } from './BookingDetailLocationDto';
import type { BookingDetailPackageDto } from './BookingDetailPackageDto';
import type { BookingDetailSessionItemDto } from './BookingDetailSessionItemDto';
import type { BookingRefundDto } from './BookingRefundDto';
import type { i } from './i';
export type ClientBookingDetailResponseDto = {
    /**
     * Booking UUID
     */
    bookingId: string;
    /**
     * Booking number
     */
    bookingNumber?: string;
    /**
     * Booking creation date
     */
    createdAt?: Record<string, any> | null;
    /**
     * Booking type
     */
    bookingType: ClientBookingDetailResponseDto.bookingType;
    /**
     * Session type
     */
    sessionType?: ClientBookingDetailResponseDto.sessionType;
    /**
     * Session mode
     */
    mode?: ClientBookingDetailResponseDto.mode;
    /**
     * Booking status
     */
    status: ClientBookingDetailResponseDto.status;
    /**
     * Total amount
     */
    totalAmount: i;
    /**
     * Payment transaction ID
     */
    transactionId?: string | null;
    /**
     * Currency code
     */
    currency: string;
    /**
     * Payment status
     */
    paymentStatus?: ClientBookingDetailResponseDto.paymentStatus;
    /**
     * Package validity start
     */
    packageValidityStart?: Record<string, any>;
    /**
     * Package validity end
     */
    packageValidityEnd?: Record<string, any>;
    /**
     * Sessions used
     */
    sessionsUsed?: Record<string, any>;
    /**
     * Sessions remaining
     */
    sessionsRemaining?: Record<string, any>;
    /**
     * Total sessions
     */
    totalSessions: number;
    /**
     * Completed sessions
     */
    completedSessions: number;
    /**
     * Session progress
     */
    sessionProgress: string;
    package?: BookingDetailPackageDto;
    /**
     * Service type name
     */
    serviceName: Record<string, any>;
    /**
     * Sub-service name
     */
    subServiceName?: Record<string, any>;
    expert: BookingDetailExpertDto;
    location?: BookingDetailLocationDto;
    sessions: Array<BookingDetailSessionItemDto>;
    cancellationRequest?: BookingCancellationDisputeDto;
    refund?: BookingRefundDto;
};
export namespace ClientBookingDetailResponseDto {
    /**
     * Booking type
     */
    export enum bookingType {
        PACKAGE = 'package',
        SINGLE_SESSION = 'single_session',
    }
    /**
     * Session type
     */
    export enum sessionType {
        SINGLE = 'single',
        DUO = 'duo',
    }
    /**
     * Session mode
     */
    export enum mode {
        ONLINE = 'online',
        CLIENT_LOCATION = 'client_location',
        EXPERT_LOCATION = 'expert_location',
    }
    /**
     * Booking status
     */
    export enum status {
        PENDING = 'pending',
        ACTIVE = 'active',
        COMPLETED = 'completed',
        CANCELLED = 'cancelled',
        PAYMENT_FAILED = 'payment_failed',
        PAYMENT_FAILED_RETRYABLE = 'payment_failed_retryable',
    }
    /**
     * Payment status
     */
    export enum paymentStatus {
        PENDING = 'pending',
        COMPLETED = 'completed',
        FAILED = 'failed',
        REFUNDED = 'refunded',
    }
}

